import styled from 'styled-components';

export const BackofficeBriefings = styled.div`
  h2 {
    font-size: 2.5em;
    padding-left: 25px;
  }

  .shadow {
    position: absolute;
  }

  @media screen and (max-width: 759px) {
    h2 {
      padding-left: 60px;
    }
    
    ul.side-bar {
      padding: 18px 16px;
      height: 61px;
        
      .show {
        min-height: 110vh;
      }
    }
  }  
`;
